module.exports = __webpack_public_path__ + "c9d745970ab37b825c2b135ce4e2f9c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/flower-white-s.png
// module id = 2672
// module chunks = 0